<template>
  <div>
    <Form
      ref="idCardForm"
      :model="idCardForm"
      :rules="idCardRules"
      class="login-form"
      :label-width="150"
    >
      <FormItem label="账号类型：" prop="idNumberType" style="margin-bottom:40px;">
        <Select v-model="idCardForm.idNumberType" placeholder="请选择账号类型" size="large" @on-select="onIdNumberTypeChange">
          <Option value="idCard" key="idCard">身份证</Option>
          <Option value="passport" key="passport">护照</Option>
          <Option value="other" key="other">其他证件</Option>
        </Select>
      </FormItem>
      <FormItem :label="idNumberTypeData.name+'号码：'" prop="idCard" style="margin-bottom:40px;">
        <Input v-model="idCardForm.idCard" :placeholder="'请输入'+idNumberTypeData.name" size="large"></Input>
      </FormItem>
      <FormItem label="密码：" prop='password' style="margin-bottom:40px;">
        <Input v-model="idCardForm.password" type="password" placeholder="请输入密码" size="large"></Input>
        <div style="color: #999; font-size: 14px; text-align: left;">登录后默认和微信绑定，下次可自动登录。</div>
      </FormItem>
     
      <FormItem class="btn-group">
        <div class="btn-wrapper">
          <Button type="info" @click="submitidcard" class="submit-btn">登录</Button>
          <Button @click="resetForm" class="reset-btn">重置</Button>
        </div>
      </FormItem>
    </Form>
    <!-- 修改密码 -->
    <Modal v-model="changePassword" title="修改密码" footer-hide :closable="false" width="40%">
      <Alert type="warning" style="margin:8px 16px 24px 16px; padding:16px 0">您当前使用的是默认密码，为确保帐号安全，请修改密码。</Alert>
      <Form
        ref="changePasswordForm"
        :model="changePasswordForm"
        :rules="rePasswordRules"
        :label-width="150"
        style="padding:0 50px"
      >
        <FormItem label="身份证：" prop="idCard" style="display:none">
          <Input type="text" v-model="changePasswordForm.idCard" placeholder="请输入身份证号码" size="large"></Input>
        </FormItem>
        <FormItem label="新密码：" prop="password" style="margin-bottom:40px">
          <Input
            type="password"
            v-model="changePasswordForm.password"
            placeholder="请输入密码"
            size="large"
          ></Input>
        </FormItem>
        <FormItem label="重复新密码：" prop="rePassword"  style="margin-bottom:40px">
          <Input
            type="password"
            v-model="changePasswordForm.rePassword"
            placeholder="请再输入密码"
            size="large"
          ></Input>
        </FormItem>
        <FormItem style=" text-align: left">
          <Button type="info" @click="updatePassword()" style="margin-left: 16px;padding:8px 30px;font-size:20px">提交</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    var idCardPass = (rule, value, callback) => {
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value === "") {
        callback(new Error("身份证号不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    var passportPass = (rule, value, callback) => {
      let reg = /^1[45][0-9]{7}$|(^[PpSs]\d{7}$)|(^[SsGgEe]\d{8}$)|(^[GgTtSsLlQqDdAaFf]\d{8}$)|(^[HhMm]\d{8,10}$)|(^[A-Za-z]{2}\d{7}$)/;
      if (value === "") {
        callback(new Error("护照号不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的护照号"));
      } else {
        callback();
      }
    };
    var accountPass = (rule, value, callback) => {
      switch (this.idNumberType) {
        case "idCard":
          idCardPass(rule, value, callback);
          break;
        case "passport":
          passportPass(rule, value, callback);
          break;
        case "other":
          if (value === "") {
            callback(new Error("证件号不能为空"));
          } else if (value.length < 5) {
            callback(new Error("证件号长度不能小于5位"));
          } else {
            callback();
          }
          break;
      }
    };
    var repassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.changePasswordForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      idNumberType: "idCard",
      isWeChatBrowser: false, //是否为微信浏览器
      accountMap: {
        idCard: {
          name: "身份证"
        },
        passport: {
          name: "护照"
        },
        other: {
          name: "其他证件"
        }
      },
      idNumberTypeData: {
        name: "身份证"
      },
      idCardForm: {
        idNumberType: "idCard",
        idCard: "",
        password: ""
      },
      idCardRules: {
        idNumberType: [{ required: true, message: "证件类型不能为空", trigger: "change" }],
        idCard: [{ required: true, validator: accountPass, trigger: "blur" }],
        password: [
          { required: true, message: "密码不能为空.", trigger: "blur" },
          {
            type: "string",
            min: 6,
            message: "密码不能少于6位",
            trigger: "blur"
          }
        ]
      },
      changePassword:false,
      changePasswordForm: {
        idCard: "",
        password: "",
        rePassword: ""
      },
      rePasswordRules: {
        password: [
          { required: true, message: "密码不能为空.", trigger: "blur" },
          {
            type: "string",
            min: 6,
            message: "密码不能少于6位",
            trigger: "blur"
          }
        ],
        rePassword: [{ required: true, validator: repassword, trigger: "blur" }]
      },
    };
  },
  created() {
    // 组件创建时检测是否为微信浏览器
    this.checkWeChatBrowser();
  },
  methods: {
    // 检查是否为微信浏览器
    checkWeChatBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isWeChat = userAgent.includes('micromessenger');
      
      if (!isWeChat) {
       
        this.isWeChatBrowser = false;
      } else {
  
        this.isWeChatBrowser = true;
      }
    },
    
    submitidcard() {
        let code = null;
        if (this.isWeChatBrowser) {
          const urlParams = new URLSearchParams(window.location.search);
          code = urlParams.get('code');

        }
        this.$refs.idCardForm.validate(valid => {
        if (valid) {
          var _this = this;
          _this.$http
            .get("retire-school-manage/login/getIdcardLoginUser", {
              params: {
                idNumberType: _this.idCardForm.idNumberType,
                idCard: _this.idCardForm.idCard.replace("x", "X"),
                password: _this.idCardForm.password,
                code: code
              }
            })
            .then(function(res) {
          
              // debugger
              if (res.data.status === 2000) {
                //登录成功 存token
                sessionStorage.removeItem("token_retire_school");
                let token = res.data.data.token;
                sessionStorage.setItem("token_retire_school", token);
                _this.$store.commit("ADD_TOKEN", token);

                sessionStorage.removeItem("userNameSchool");
                let userName = res.data.data.name;
                sessionStorage.setItem("userNameSchool", userName);

                 sessionStorage.removeItem("idCard");
                let idCard = res.data.data.idCard;
                sessionStorage.setItem("idCard", idCard);

                sessionStorage.removeItem("idNumberType");
                let idNumberType = res.data.data.idNumberType;
                sessionStorage.setItem("idNumberType", idNumberType);

                let studentId = res.data.data.id;
                sessionStorage.setItem("studentId", studentId);
                _this.$store.commit("ADD_STUDENTID", studentId);
 
                sessionStorage.setItem("id", res.data.data.openId);
          
                _this.$router.push({ name: "home" });

              } else if (res.data.status === 2009) {
                //强制修改密码
                _this.changePasswordForm.idCard = _this.idCardForm.idCard;
                _this.changePassword = true;
                sessionStorage.setItem("id", res.data.data.openId);
              }else if(res.data.status === 2005){
                res.data.data.idCard = _this.idCardForm.idCard;
                res.data.data.idNumberType = _this.idCardForm.idNumberType;
               
                sessionStorage.setItem("id", res.data.data.openId);
 
                 _this.$router.push({ path: '/userInfoConfirm',query:res.data.data});
              }else if(res.data.status === 2010){

                sessionStorage.setItem("id", res.data.data.openId);
                _this.$router.push({ path: '/userInfoConfirm',query:res.data.data});
              }else {
                _this.$CustomMessageError(res.data.msg);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          this.$CustomMessageError("表单验证未通过!");
        }
      });
    },
    onIdNumberTypeChange(type) {
      this.idNumberType = type;
      this.idNumberTypeData = this.accountMap[type];
      this.resetForm();
      return type;
    },
    resetForm() {
         this.$refs.idCardForm.resetFields();
    },
     updatePassword() {
       var _this = this;
       _this.changePassword = false
      this.$refs.changePasswordForm.validate(valid => {
        if (valid) {

          _this.$http
            .post("retire-school-manage/login/addIdcardLogin", {
              idNumberType: _this.idCardForm.idNumberType,
              idCard: _this.changePasswordForm.idCard.replace("x", "X"),
              password: _this.changePasswordForm.password
            })
            .then(function(res) {
               _this.changePassword = false
              if (res.data.status === 2000) {
              // _this.changePassword = false
                //修改密码成功 存token
              sessionStorage.removeItem("token_retire_school");
                let token = res.data.data.token;
                sessionStorage.setItem("token_retire_school", token);
                _this.$store.commit("ADD_TOKEN", token);

                sessionStorage.removeItem("userNameSchool");
                let userName = res.data.data.name;
                sessionStorage.setItem("userNameSchool", userName);

                sessionStorage.removeItem("idCard");
                let idCard = res.data.data.idCard;
                sessionStorage.setItem("idCard", idCard);

                sessionStorage.removeItem("idNumberType");
                let idNumberType = res.data.data.idNumberType;
                sessionStorage.setItem("idNumberType", idNumberType);

                let studentId = res.data.data.id;
                sessionStorage.setItem("studentId", studentId);
                _this.$store.commit("ADD_STUDENTID", studentId);
                _this.$router.push({ name: "home" });

              }else if(res.data.status === 2005){
                _this.changePassword = false
                console.log("changePassword",_this.changePassword)
                res.data.data.idCard = _this.idCardForm.idCard;
                res.data.data.idNumberType = _this.idCardForm.idNumberType;
                _this.$router.push({ path: '/userInfoConfirm',query:res.data.data});
              } else {
                _this.$CustomMessageError(res.data.msg);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          this.$CustomMessageError("表单验证未通过!");
        }
      });
    }
  }
};
</script>
<style>
.login-form {
  padding: 0 80px;
}

.ivu-input-large {
  padding: 20px !important;
  font-size: 18px;
}

@media screen and (max-width: 768px) {
  .login-form {
    padding: 0 16px;
  }

  .ivu-form-item {
    margin-bottom: 20px;
  }

  .ivu-form-item-label {
    text-align: left;
    padding: 0 0 10px 0;
    width: auto !important;
    font-size: 18px !important;
    line-height: 1.5;
  }

  .ivu-input-large {
    padding: 12px !important;
    font-size: 15px;
    height: 44px;
  }

  .ivu-form-item-content {
    margin-left: 0 !important;
  }

  .ivu-modal {
    width: 90%;
    margin: 0 auto;
  }

  .btn-group {
    margin-top: 40px;
  }

  .btn-wrapper {
    flex-direction: column;
    gap: 32px;
    width: 100%;
  }

  .submit-btn, .reset-btn {
    width: 100%;
    margin: 0 !important;
    height: 46px;
    font-size: 16px;
    border-radius: 6px;
  }
}

@media screen and (max-width: 375px) {
  .ivu-form-item-label {
    font-size: 15px;
  }

  .ivu-input-large {
    font-size: 14px;
  }
}

.btn-group {
  margin-top: 20px;
}

.btn-wrapper {
  display: flex;
  gap: 16px;
}

.submit-btn, .reset-btn {
  padding: 8px 30px;
  font-size: 20px;
}
</style>
